/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <polygon points="23.5 17.482 11.5 17.482 7.5 21.482 7.5 17.482 0.5 17.482 0.5 2.482 23.5 2.482" />
      <polyline points="12.5 14.482 12.5 8.482 10.5 8.482" />
      <path d="M10.5,14.482 L14.5,14.482" />
      <path d="M12.5,5.982 C12.5,6.258 12.276,6.482 12,6.482 C11.724,6.482 11.5,6.258 11.5,5.982 C11.5,5.706 11.724,5.482 12,5.482 C12.276,5.482 12.5,5.706 12.5,5.982 Z" />
    </g>
  </svg>
);

export default Icon;
